import makeApi from '@lib/api'

export default {
  deleteAccount: async () => {
    const callApi = makeApi.remove<{}, void>('/customer', { attachRpn: true })

    return await callApi({ params: {} })
  },
}
